import type { FetchResult } from '@apollo/client';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import type { UserConfigurationArgs } from 'owa-graph-schema';
import { updateUserConfiguration } from 'owa-session-store/lib/actions/updateUserConfiguration';
import { createUserConfigurationUpdateFunction } from './createUserConfigurationUpdateFunction';
import { type UpdateOperationType, updateOperationMap } from './updateUserConfigurationTypes';

export function updateUserConfigurationAndService(
    updates: UserConfigurationArgs,
    updateOperationType: UpdateOperationType = 'UserConfiguration'
): Promise<FetchResult> {
    updateUserConfiguration(createUserConfigurationUpdateFunction(updates));

    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    return updateOperationMap[updateOperationType].importAndExecute(mailboxInfo, updates);
}
